import * as React from 'react';

interface PrintWhiteHintProps {
    printWhite: boolean | null;
}

/**
 * Informational hint, shown next to the Blending Mode selector and the Color Profile picker,
 * indicating whether DIS's white-layer data expects a white underbase for the current product's
 * currently selected size/color — and, since that maps directly to a blending mode choice (see
 * `auto-scene`'s own `derive_blend_mode()`: white underbase → Normal, no white underbase →
 * Multiply), names that expected mode directly rather than leaving the designer to work out the
 * mapping themselves. Purely advisory — it never changes the designer's selected blending mode or
 * color profile, it only helps them sanity check it. Hidden when DIS has no definitive verdict for
 * the current selection (e.g. non-apparel products, or apparel not routed for this data).
 *
 * See ai-config/user-stories/apparel-positioning-and-auto-placement/summary.md, unit A5.
 */
export default function PrintWhiteHint({ printWhite }: PrintWhiteHintProps) {
    if (printWhite === null) {
        return null;
    }

    return (
        <div className='advanced_print-white-hint'>
            {printWhite ? (
                <>
                    White underbase: <strong>Normal</strong>
                </>
            ) : (
                <>
                    No white underbase: <strong>Multiply</strong>
                </>
            )}
        </div>
    );
}
